const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
const MissionExcerpt = () => import("@/components/MissionExcerpt/MissionExcerpt.vue");
import { mapGetters } from "vuex";
export default {
  components: {
    SectionTitle,
    MissionExcerpt,
  },
  data() {
    return {
      missions: [],
      googleApiKey:  window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
      ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
    };
  },
  computed: {
    ...mapGetters('auth', {
      generalSetting : 'generalSetting'
    })
  },
  methods:{
    redirectToPostTulerUrl() {
      if(this.generalSetting.redirectPageToApply) {
        window.location.replace(this.generalSetting.redirectPageToApply)
      } else {
        this.$router.push({name: 'sign-up'})
      }
    }
  }
};
